'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {communicationSubjectModel} from "../../models/communicationsubjectmodel.js";
import {CommunicationSubjectEditorCtrl} from './communicationsubjecteditorctrl.js';
import {CommunicationMetadataCtrl} from './communicationmetadatactrl.js';

export class CommunicationMessageListCtrl
{
	$scope;
	
	$mdDialog;
	
	jsDataService;
	
	firstMessage;
	
	lastMessage;
	
	messages;
	
	restMessages = [];
	
	appName;
	
	canWrite;
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService, $mdDialog){
		this.$mdDialog = $mdDialog;
		this.$scope = $scope;
		this.jsDataService = jsDataService;
		this.appName = jsDataService.get('cfgAppName');
		this.messages = jsDataService.get('messages') || [];
		this.canWrite = jsDataService.get('canWrite', false);
		this.loadData()
			.then((response) => {
				this.recordView();
			});
		
	}
	
	recordView() {
		const messages = this.messages
			.filter((message) => !message.received || message.received.view_time == 0)
			.map((message) => message.id);
	
		if(!messages.length) {
			return;
		}
		
		this.$scope.basicHttpConfigProcess({
			url: this.jsDataService.get('cfgViewUrl'),
			method: 'POST',
			data: {
				messages,
			}
		})
		.then((response) => {
			console.log(response);
		});
	}
	
	newMessageDialog(ev){
		const draftMessage = this.jsDataService.get('draftMessage');

		const subject = new communicationSubjectModel({
			id: draftMessage?.id || '',
			parent_id: this.firstMessage.id,
			subject: this.firstMessage.subject,
			message: draftMessage?.message || '',
			delete_url: draftMessage?.delete_url || '',
			attachment: draftMessage?.attachment || []
		});
		
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'subject', CommunicationSubjectEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'communication/subject_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject,
			}
		}).then((results) => {
			this.saveSubject(results)
				.then((response) => {
					if(response.data.success) {
						this.publishSubject(response.data.data);
					}
				});
		}, (results) => {
		});
	}
	
	saveSubject(data){
		const draftMessage = this.jsDataService.get('draftMessage');
		const autosave = this.jsDataService.get('autosave');
		
		return this.$scope.basicHttpConfigProcess({
			url: autosave.url,
			method: 'POST',
			data: {
				id: data.id,
				parent_id: data.parent_id,
				subject: data.subject,
				message: data.message,
				attachment: data.attachment.map(({id, file_id}) => ({id, file_id})),
			}
		});
	}
	
	publishSubject(data){
		this.$scope.basicHttpConfigProcess({
			url: data.publish_url,
			method: 'POST',
		}).then((response) => {
			if(response.data.success){
				this.loadData();
				this.jsDataService.set('draftMessage', null);
			}
		}, () => {});
	}
	
	loadData(){
		return this.$scope.basicHttpConfigProcess({
			url: this.jsDataService.get('cfgDataUrl'),
			method: 'GET',
		}).then((response) => {
			if(response.data.data) {
				this.messages = response.data.data;
				this.firstMessage = this.messages[0];
			}
			
			return response;
		}, () => {});
	}
	
	openMetadataDialog(ev, message) {
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'message', CommunicationMetadataCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'communication/message_metadata.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				message: message,
			}
		}).then((results) => {
			
		}, (results) => {
		});
	}
}